import * as z from "zod/mini";

// Our CSP forbids eval, so zod's `new Function` probe always fails and is reported as a CSP violation on every page
// load. jitless skips the probe; the eval fast path it would enable is blocked by the CSP anyway.
z.config({ jitless: true });
z.config(z.locales.en());
